import axios from "axios";
import {
  BASE_URL,
  LOGIN_API,
  ANNOUNCEMENT_GETANNOUNCEMENTDATA,
  GET_TOURNAMENT_TEAM_MATCH,
  TOURNAMENT_UPDATE_PLAYER_MATCH_DATE,
  ANNOUNCEMENT_GETWINNERDEATILS,
  GET_BID_AMOUNT_REPORT,
  ANNOUNCEMENT_GETALLAUCTION,
  MANAGER_GETBYID,
  BID_GETBIDWITHSTATUS,
  USER_GetAll,
  FORGET_API,
  LINK_VERIFY_API,
  UPDATE_PASSWORD_API,
  CHANGE_PASSWORD_API,
  ORGANIZATION_REGISTRATION_API,
  ORGANIZATION_GETALL_API,
  ORGANIZATION_Delete_API,
  ORGANIZATION_ViewID_API,
  ORGANIZATION_Update_API,
  ORGANIZATION_Country_API,
  ORGANIZATION_State_API,
  ORGANIZATION_City_API,
  ORGANIZATION_GetRecent,
  ORGANIZATION_TotalCount,
  USER_REGISTRATION_API,
  USER_TotalCount,
  SPORTS_REGISTRATION_API,
  UPLOAD_IMAGE,
  SPORTS_GETALL,
  SPORTS_DELETE,
  SPORTS_Total,
  SPORTS_UPDATE,
  WEB_ADMIN_PROFILE,
  USER_GETID,
  TEAM_GETALL_API,
  TEAM_REG_API,
  TEAM_DELETE_API,
  TEAM_UPDATE_API,
  EMAIL_EXISTS,
  TEAM_TOTAL_API,
  TOURNAMENT_REG,
  TOURNAMENT_GET,
  TOURNAMENT_DELETE,
  TOURNAMENT_GET_COUNT,
  TOURNAMENT_UPDATE,
  AUCTION_REG,
  AUCTION_GET_ALL,
  AUCTION_GET_COUNT,
  AUCTION_DELETE_API,
  AUCTION_UPDATE,
  BID_GET_COUNT,
  AUCTION_GETBYID,
  REG_BID,
  GETALL_BID,
  TOURNAMENT_GET_ID,
  TOURNAMENT_GET_ID_BRACKETS,
  TOURNAMENT_BRACKETS_ID,
  AUCTION_RECENT,
  PAYMENT_ADD,
  NOTIFICATION_MESSAGE,
  NOTIFICATION_MESSAGE_REG,
  TEAMGETBYSPORT,
  AUCTIONWININGCOUNT,
  AUCTIONGETTEAM,
  GETBIDBYMANAGER,
  CUSTOMER_PAYMENT,
  CHECKOUTPAYMENT,
  RECENT_BID,
  ADMIN_GET,
  ADMIN_REGISTER,
  TOURNAMENT_GET_RECENT,
  CHECKOUTPAYMENTSTATUS,
  PAYMENTHISTORY,
  BID_STATUS,
  BRACKETSUFFLE,
  GETBYIDPAYMENT,
  REFRESH_TOKEN_API,
  AUCTION_AUCTIONDATABYFILTER,
  SECODARY_MARKETAUCTION,
  SECODARY_MARKETAUCTION_WINNER,
  TOURNAMENT_BRACKETS_UPDATE,
  TOURNAMENT_BRACKETS_DATE,
  AUCTION_AUCTIONPLAYPAUSESTATUS,
  CONTACTUS,
  CONTACTUSDETAILS,
  INVOICEDETAILS,
  MANAGER_GETALL,
  PLAYER_SUBSCRIBEMANAGER,
  SECODARY_MARKETAUCTION_SMBIDSELL,
  MANAGER_GETPLAYERREQUEST,
  MANAGER_PLAYERAPPROVAL,
  PLAYER_GETSUBSCRIBE_MANAGER,
  GETBIDWINNER,
  GETBIDCOUNTDATA,
  SMREG_BID,
  SECONDARYBIDH,
  BID_GETAUCTION_TEAMWINNER,
  SUBCRIPTIONREVENUE,
  SECODARY_MARKETAUCTION_ANNOUNCEMENT,
  REPORTDATAAPI,
  SUBSCRIPTION_CONT,
  SM_MY_BID_HISTORY,
  CREATEPAYMENTURL,
  COMMON_REDEEM_PROMOCODE,
  COMMON_GENERATE_PROMOCODE,
  TOURNAMENT_UPDATE_PLAYER_MATCH_SCORE,
  COMMON_GET_PROMOCODES,
  SPORTS_GETID,
  GETSUBSCRIPTIONDETAILS,
  SECODARY_MARKETAUCTION_SMGETAUCTIONBYID,
  AUCTION_TEAM_GET,
  AUCTION_SHOWPLACEBID,
} from "../../utils/config/config";
import { GetRefreshToken, GetToken, GetUser } from "../../utils/helper/helper";

export const loginUserAPI = async (userData) => {
  try {
    const response = await axios.post(BASE_URL + LOGIN_API, userData);
    localStorage.setItem("isToken", response.data.token);
    localStorage.setItem("isRefreshToken", response.data.refreshToken);
    return response;
  } catch (error) {
    return error;
  }
};

export const TournamentRegApi = async (userData) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + TOURNAMENT_REG,
      userData,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SubscribeManager = async (managerId) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      `${BASE_URL + PLAYER_SUBSCRIBEMANAGER}?managerId=${managerId}`,
      {},
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SubscriptionDataFilterByDate = async (
  startAuctionDate,
  endAuctionDate
) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${
        BASE_URL + SUBCRIPTIONREVENUE
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SecondaryMarketAnnouncement = async (data) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      `${BASE_URL + SECODARY_MARKETAUCTION_ANNOUNCEMENT}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GetTournamentTeamMatch = async (GetId) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      BASE_URL + GET_TOURNAMENT_TEAM_MATCH + GetId,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionRegApi = async (userData) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(BASE_URL + AUCTION_REG, userData, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const AddPayment = async (userData) => {
  try {
    const response = await axios.post(BASE_URL + PAYMENT_ADD, userData);
    return response;
  } catch (error) {
    return error;
  }
};

export const OrganizationReg = async (userData) => {
  try {
    const response = await axios.post(
      BASE_URL + ORGANIZATION_REGISTRATION_API,
      [userData]
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SportsReg = async (userData) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + SPORTS_REGISTRATION_API,
      userData,
      config
    );
    return response;
  } catch (err) {}
};

export const UploadImage = async (userData) => {
  try {
    var token = GetToken();
    let config = {
      method: "post",

      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + UPLOAD_IMAGE,
      userData,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const UserReg = async (userData) => {
  try {
    const response = await axios.post(
      BASE_URL + USER_REGISTRATION_API,
      userData
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const NotificationReg = async (updatedata) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + NOTIFICATION_MESSAGE_REG,
      updatedata,
      config
    );
    return response.data;
  } catch (error) {}
};

export const BidReg = async (userData) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(BASE_URL + REG_BID, userData, config);
    return response;
  } catch (error) {
    return error;
  }
};
export const SmBidReg = async (userData) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(BASE_URL + SMREG_BID, userData, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const OragnizationAll = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ORGANIZATION_GETALL_API,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionAll = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + BID_GETBIDWITHSTATUS, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionGetAll = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + AUCTION_GET_ALL, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionPlaceBid = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BASE_URL + AUCTION_SHOWPLACEBID}?auctionId=${data}`, config);
    return response;
  } catch (error) {
    return error;
  }
};


export const GetNotificationMes = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + NOTIFICATION_MESSAGE, config);
    return response.data;
  } catch (error) {}
};

export const AuctionRecent = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + AUCTION_RECENT, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionCount = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + AUCTION_GET_COUNT, config);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const TournamentAll = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + TOURNAMENT_GET, config);
    return response;
  } catch (error) {
    return error?.data?.response;
  }
};

export const TournamentGetCount = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + TOURNAMENT_GET_COUNT, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const RecentBidGet = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + RECENT_BID, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamReg = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + TEAM_REG_API,
      userData,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const CustomerAddPayment = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + CUSTOMER_PAYMENT,
      userData,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const ContactUsAPI = async (userData) => {
  try {
    // let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(BASE_URL + CONTACTUS, userData, config);
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const CheckoutAddPayment = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + CHECKOUTPAYMENT,
      userData,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const CreatePymenentUrlFn = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${BASE_URL + CREATEPAYMENTURL}=${userData}`,
      {},
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

let timeout = null;

export function debounce(func, delay) {
  return () => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      return func();
    }, delay);
  };
}

export const RefreshToken = debounce(async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const payload = {
      status: true,
      token: token,
      refreshToken: GetRefreshToken(),
      message: "string",
    };
    const response = await axios.post(
      BASE_URL + REFRESH_TOKEN_API,
      payload,
      config
    );

    localStorage.setItem("isToken", response.data.token);
    localStorage.setItem("isRefreshToken", response.data.refreshToken);

    return response;
  } catch (err) {
    console.error("Error refreshing token:", err);
    return err?.response?.data;
  }
}, 1000);

export const TournamentUpdatePlayerMatchDate = async (item) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      BASE_URL + TOURNAMENT_UPDATE_PLAYER_MATCH_DATE,
      item,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const TournamentUpdatePlayerMatchScore = async (item) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      BASE_URL + TOURNAMENT_UPDATE_PLAYER_MATCH_SCORE,
      item,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const GetPromoCodes = async () => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(BASE_URL + COMMON_GET_PROMOCODES, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const SecondaryMarketMyBidHistory = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + SM_MY_BID_HISTORY, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionDataFilterByDate = async (
  startAuctionDate,
  endAuctionDate
) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${
        BASE_URL + AUCTION_AUCTIONDATABYFILTER
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const CheckoutAddPaymentStatus = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + CHECKOUTPAYMENTSTATUS, config);
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const SecondaryMarketAuction = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + SECODARY_MARKETAUCTION, config);
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const AuctionPlayPause = async (auctionId, pause) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${
        BASE_URL + AUCTION_AUCTIONPLAYPAUSESTATUS
      }?auctionId=${auctionId}&playPauseAuction=${pause}`,
      {},
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const PaymentGetById = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    // const response = await axios.get(BASE_URL + GETBYIDPAYMENT, config);
    const response = await axios.get(
      `${BASE_URL + GETBYIDPAYMENT}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (err) {
    return err?.response?.data;
  }
};
export const GetBidCountDetail = async (id) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + GETBIDCOUNTDATA, config);

    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const SportAllMap = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + SPORTS_GETALL, config);
    return response;
  } catch (error) {
    return error;
  }
};
export const RedeemPromoCode = async (promoCode) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + COMMON_REDEEM_PROMOCODE}?promoCode=${promoCode}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GeneratePromoCode = async (endDate) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      `${BASE_URL + COMMON_GENERATE_PROMOCODE}?endDate=${endDate}`,
      {},
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const PaymentHistory = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + PAYMENTHISTORY, config);
    return response;
  } catch (error) {
    return error;
  }
};
export const BidStatus = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BASE_URL + BID_STATUS}`, config);

    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionGetTeam = async (id) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + AUCTIONGETTEAM}?auctionId=${id}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SportAll = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SPORTS_GETALL}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const SportAllSearch = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SPORTS_GETALL}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionGetAllData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + AUCTION_GET_ALL}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionGetAllDataSearch = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + AUCTION_GET_ALL}?SearchTerm=${
        data?.SearchTerm
      }&SortColumn=${data?.SortColumn}&SortOrder=${data?.SortOrder}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const EmailCheck = async (userData) => {
  try {
    const response = await axios.get(
      `${BASE_URL + EMAIL_EXISTS}?emailId=${userData.email}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const UserAll = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + USER_GetAll, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const SecodaryBidHistory = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + SECONDARYBIDH, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const BidAll = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + GETALL_BID, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamGetAll = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + TEAM_GETALL_API, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamAll = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + TEAM_GETALL_API}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamAllSearch = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + TEAM_GETALL_API}?SearchTerm=${
        data?.SearchTerm
      }&SortColumn=${data?.SortColumn}&SortOrder=${data?.SortOrder}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const BidWinnerListData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + GETBIDWINNER}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};
export const GetAnnouncementGetAllAuctionData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + ANNOUNCEMENT_GETALLAUCTION}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    // const response = await axios.get(BASE_URL + ANNOUNCEMENT_GETALLAUCTION, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetNotificationMesData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + NOTIFICATION_MESSAGE}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response.data;
  } catch (error) {}
};

export const ManagerGetPlayerRequestData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + MANAGER_GETPLAYERREQUEST}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const AuctionGetAllDataWeb = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + AUCTION_GET_ALL}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SecondaryMarketAnnouncementData = async (data) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      `${BASE_URL + SECODARY_MARKETAUCTION_ANNOUNCEMENT}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const AdminGetData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + ADMIN_GET}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const SecondaryMarketAuctionSell = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SECODARY_MARKETAUCTION}?SearchTerm=${data.SearchTerm}&SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

// export const GetWinnerAuctionData = async (data) => {
//   try {
//     let token = GetToken();
//     let config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const response = await axios.get(
//       `${BASE_URL + SECODARY_MARKETAUCTION_WINNER}?SortOrder=${
//         data?.SortOrder
//       }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
//       config
//     );
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

export const GetWinnerAuctionData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    // const response = await axios.get(
    //   `${BASE_URL + SECODARY_MARKETAUCTION_WINNER}?SortOrder=${
    //     data?.SortOrder
    //   }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
    //   config
    // );
     const response = await axios.get(
      `${BASE_URL + SECODARY_MARKETAUCTION_WINNER}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}&PageNumber=${data?.PageNumber}&PageSize=${
        data?.PageSize
      }`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GetAnnouncementGetAllAuctionData2 = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + ANNOUNCEMENT_GETALLAUCTION}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SecondaryMarketAnnouncementData2 = async (data) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SECODARY_MARKETAUCTION_ANNOUNCEMENT}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GetContactUsDetailsData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + CONTACTUSDETAILS}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GetPromoCodesData = async (data) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      `${BASE_URL + COMMON_GET_PROMOCODES}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const GetInvoiceDetailsData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      `${BASE_URL + INVOICEDETAILS}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const OragnizationAllData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + ORGANIZATION_GETALL_API}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const UserAllData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + USER_GetAll}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}&SearchTerm=${data?.SearchTerm}&SortColumn=${data?.SortColumn}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SecodaryBidHistoryData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SECONDARYBIDH}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const SecondaryMarketMyBidHistoryData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SM_MY_BID_HISTORY}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};
export const SecondaryMarketAuctionData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + SECODARY_MARKETAUCTION}?PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};
export const GetNotificationMesDataPlayer = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + NOTIFICATION_MESSAGE}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
      config
    );
    return response.data;
  } catch (error) {}
};

export const BidStatusData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + BID_STATUS}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}&PageNumber=${data?.PageNumber}&PageSize=${
        data?.PageSize
      }`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const BidAllData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      `${BASE_URL + GETALL_BID}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );

    return response;
  } catch (error) {
    return error;
  }
};
export const TournamentAllData = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + TOURNAMENT_GET}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`,
      config
    );
    return response;
  } catch (error) {
    return error?.data?.response;
  }
};

export const TournamentAllDataSearch = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + TOURNAMENT_GET}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}`,
      config
    );
    return response;
  } catch (error) {
    return error?.data?.response;
  }
};

export const MangergetBid = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + GETBIDBYMANAGER}?id=${data}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AuctionTeamById = async (data) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + AUCTION_TEAM_GET}?auctionId=${data?.auctionId}&teamId=${
        data?.teamId
      }`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const ManagerGetById = async (id) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BASE_URL + MANAGER_GETBYID}`, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const PlayerGetById = async (id) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BASE_URL + USER_GETID}${id}`, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const SportGetById = async (id) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BASE_URL + SPORTS_GETID}${id}`, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const WinCount = async (id) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + AUCTIONWININGCOUNT}?NoOfTeams=${id}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamTotal = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + TEAM_TOTAL_API, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetWinnerAuction = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + SECODARY_MARKETAUCTION_WINNER,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GetReportData = async (startAuctionDate, endAuctionDate) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${
        BASE_URL + REPORTDATAAPI
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const GetBidAmountReport = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + GET_BID_AMOUNT_REPORT, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetSubscriptionCount = async (
  startAuctionDate,
  endAuctionDate
) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${
        BASE_URL + SUBSCRIPTION_CONT
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SecondaryMarketBidSell = async (userData) => {
  var token = GetToken();
  try {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + SECODARY_MARKETAUCTION_SMBIDSELL,
      userData,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const ManagerGetPlayerRequest = async (userId) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + MANAGER_GETPLAYERREQUEST}`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const managerApproval = async (playerId, approval) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(
      `${
        BASE_URL + MANAGER_PLAYERAPPROVAL
      }?playerId=${playerId}&approved=${approval}`,
      {},
      config
    );
    return response.data;
  } catch (error) {}
};

export const PlayerGetSubscribeManager = async (playerId) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${BASE_URL + PLAYER_GETSUBSCRIBE_MANAGER}`,
      config
    );
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const ManagerGetAll = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + MANAGER_GETALL, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const BidWinnerList = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + GETBIDWINNER, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetInvoiceDetails = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + INVOICEDETAILS, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetSubScription = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + GETSUBSCRIPTIONDETAILS, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetContactUsDetails = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + CONTACTUSDETAILS, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const OragnizationGetRecent = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + ORGANIZATION_GetRecent, config);
    return response;
  } catch (error) {
    return error;
  }
};
export const OragnizationGetTotal = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ORGANIZATION_TotalCount,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const UserGetTotal = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + USER_TotalCount, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const OragnizationCounrty = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ORGANIZATION_Country_API,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const OragnizationStates = async (countryId) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ORGANIZATION_State_API + countryId,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const OragnizationCity = async (stateId) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ORGANIZATION_City_API + stateId,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SportTotalGet = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + SPORTS_Total, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const OragnizationDelete = async (id, token) => {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.delete(
      BASE_URL + ORGANIZATION_Delete_API + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const TeamDelete = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.delete(
      BASE_URL + TEAM_DELETE_API + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const AuctionDelete = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.delete(
      BASE_URL + AUCTION_DELETE_API + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const TournamentDelete = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.delete(
      BASE_URL + TOURNAMENT_DELETE + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const AuctionBYIdGet = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(
      BASE_URL + AUCTION_GETBYID + "/" + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const SecondryMarketSMgetAuctionById = async (data) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  let info = `?auctionId=${data.auctionId}&teamId=${data.teamId}&auctionLevel=${data.auctionLevel}`;
  try {
    const response = await axios.get(
      BASE_URL + SECODARY_MARKETAUCTION_SMGETAUCTIONBYID + info,
      config
    );
    return response.data;
  } catch (error) {}
};

export const GetAnnouncementGetAllAuction = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ANNOUNCEMENT_GETALLAUCTION,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AnnouncementData = async (auctionId) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        auctionId: auctionId,
      },
    };
    const response = await axios.get(
      BASE_URL + ANNOUNCEMENT_GETANNOUNCEMENTDATA,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const AnnouncemnetWinnerDetails = async (auctionId) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        auctionId: auctionId,
      },
    };
    const response = await axios.get(
      BASE_URL + ANNOUNCEMENT_GETWINNERDEATILS,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const UserGetId = async (id) => {
  try {
    const user = JSON.parse(GetUser());
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      BASE_URL + ORGANIZATION_ViewID_API + user?.userId,
      config
    );
    return response.data;
  } catch (error) {}
};

export const AdminReg = async (userData) => {
  try {
    var token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + ADMIN_REGISTER,
      userData,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const AdminGet = async (userData) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + ADMIN_GET, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const SportDelete = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.delete(BASE_URL + SPORTS_DELETE + id, config);
    return response.data;
  } catch (error) {}
};

export const OragnizationViewId = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(
      BASE_URL + ORGANIZATION_ViewID_API + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const TournamentGetById = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(BASE_URL + TOURNAMENT_GET_ID + id, config);
    return response.data;
  } catch (error) {}
};

export const TournamentGetByIdGet = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(
      BASE_URL + `${TOURNAMENT_GET_ID}${id}`,
      config
    );
    return response.data;
  } catch (error) {}
};

export const TournamentGetByIdBarcket = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(
      BASE_URL + TOURNAMENT_GET_ID_BRACKETS + id,
      config
    );
    return response.data;
  } catch (error) {}
};

export const TeamGetBy = async (id) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(BASE_URL + TEAMGETBYSPORT + id, config);
    return response.data;
  } catch (error) {}
};

export const TournamentBarcketId = async (GetId) => {
  let token = GetToken();
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(
      BASE_URL + TOURNAMENT_BRACKETS_ID + GetId,
      config
    );
    return response.data;
  } catch (error) {}
};

export const OragnizationUpdate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(
      BASE_URL + ORGANIZATION_Update_API,
      [
        {
          ...item,
          crudOperationId: false,
        },
      ],
      config
    );
    return response.data;
  } catch (error) {}
};

export const TournamentUpdateTeamScore = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + TOURNAMENT_BRACKETS_UPDATE,
      item,
      config
    );
    return response.data;
  } catch (error) {}
};

export const TournamentUpdateTeamDate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + TOURNAMENT_BRACKETS_DATE,
      item,
      config
    );
    return response.data;
  } catch (error) {}
};

export const WebAdminProfile = async (item, token) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(
      BASE_URL + WEB_ADMIN_PROFILE,
      item,
      config
    );
    return response.data;
  } catch (error) {}
};

export const BracketUpdate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(BASE_URL + BRACKETSUFFLE, item, config);
    return response.data;
  } catch (error) {}
};

export const AuctionUpdate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(BASE_URL + AUCTION_UPDATE, [item], config);
    return response.data;
  } catch (error) {}
};

export const TournamentUpdate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(
      BASE_URL + TOURNAMENT_UPDATE,
      [item],
      config
    );
    return response.data;
  } catch (error) {}
};

export const TeamUpdate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(
      BASE_URL + TEAM_UPDATE_API,
      [{ ...item }],
      config
    );
    return response.data;
  } catch (error) {}
};

export const SportsUpdate = async (item) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(
      BASE_URL + SPORTS_UPDATE,
      [{ ...item }],
      config
    );
    return response.data;
  } catch (error) {}
};

export const ForgetPasswordEmailSend = async (userPass) => {
  try {
    const email = userPass.email;
    const response = await axios.post(
      `${BASE_URL + FORGET_API}?email=${encodeURIComponent(email)}`
    );
    return response.data;
  } catch (error) {}
};

export const linkVerify = async (value) => {
  try {
    const response = await axios.post(
      `${BASE_URL + LINK_VERIFY_API}?token=${value}`
    );
    return response.data;
  } catch (error) {}
};

export const UpdatePasswordFn = async (updatedata) => {
  try {
    const response = await axios.post(
      BASE_URL + UPDATE_PASSWORD_API,
      updatedata
    );
    return response.data;
  } catch (error) {}
};

export const ChangePasswordApi = async (updatedata) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      BASE_URL + CHANGE_PASSWORD_API,
      updatedata,
      config
    );
    return response.data;
  } catch (error) {}
};

export const getBIdCount = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + BID_GET_COUNT, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const BidAuctionTeamWinner = async (auctionId, teamId, market) => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${
        BASE_URL + BID_GETAUCTION_TEAMWINNER
      }?AuctionId=${auctionId}&TeamId=${teamId}&Market=Primary`,
      config
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const getRecentTournament = async () => {
  try {
    let token = GetToken();
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(BASE_URL + TOURNAMENT_GET_RECENT, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const authService = {
  loginUserAPI,
};

export default authService;
